// Grids & Gantts — the pin: a column pinned at the left wears it on its
// heading, and Page settings shows it beside the pinned columns. A drawing,
// not an emoji, so it is the same small grey mark on every platform.
export default function PinIcon({ size = 11, color = 'currentColor', title = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" aria-hidden={title ? undefined : true} role={title ? 'img' : undefined}>
      {title ? <title>{title}</title> : null}
      <path d="M10.2 1.6l4.2 4.2-1.3 1.3-0.9-0.4-2.6 2.6 0.3 2.9-1.3 1.3-2.6-2.6-3.6 3.6-0.9-0.9 3.6-3.6-2.6-2.6 1.3-1.3 2.9 0.3 2.6-2.6-0.4-0.9z"
        fill={color} />
    </svg>
  );
}
